import { render, staticRenderFns } from "./chip-status.vue?vue&type=template&id=0f322b72"
import script from "./chip-status.vue?vue&type=script&lang=js"
export * from "./chip-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports